import { connect } from 'react-redux';
import EditEntity from '../components/EntityEditing/EditEntity';

const mapStateToProps = state => ({
  loadingOverwrites: state.refereeOverwrites.loading,
  writing: state.refereeOverwrites.writing,
  overwrites: state.refereeOverwrites.overwrites,
  writeError: state.refereeOverwrites.writeError,
  fetchOverwriteError: state.refereeOverwrites.error,
  currentEdits: state.edits.currentEdits,
  editsDirty: state.edits.dirty,
});

export default connect(mapStateToProps)(EditEntity);
